// Phase 7.0 Stage 1 — visual identity foundation: ambient background.
//
// A single fixed, full-viewport layer rendered once at the App root,
// sitting BEHIND all content (z-index: -1 via .ambient-bg). It paints
// the LCH-tinted ambient gradient (depth) plus a soft corner orb
// (implied lighting). Page-root containers are transparent so this
// reads through; opaque surfaces (cards, panes, nav bars) sit on top.
//
// Purely decorative: aria-hidden and pointer-events:none, so it never
// intercepts clicks or reaches assistive tech. All visual values live
// in globals.css (.ambient-bg / .ambient-orb + the --ambient-gradient
// / --orb-color tokens with OKLCH + RGB fallback).

export function AmbientBackground() {
  return (
    <div data-testid="ambient-background" aria-hidden="true" className="ambient-bg">
      {/* Aurora — the violet corner orb (original) plus three colour
          orbs (indigo / cyan / magenta) painting the dark-glass aurora.
          All decorative; .ambient-* styles live in globals.css. */}
      <div data-testid="ambient-orb" className="ambient-orb" />
      <div data-testid="ambient-orb-indigo" className="ambient-orb-indigo" />
      <div data-testid="ambient-orb-cyan" className="ambient-orb-cyan" />
      <div data-testid="ambient-orb-magenta" className="ambient-orb-magenta" />
    </div>
  );
}
